export default __webpack_public_path__ + "static/media/cohort-checkin.eb7683f7.svg";